import React, { useEffect, useState } from "react";
import { useFormik, FieldArray } from "formik";
import * as Yup from "yup";

import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import PurchaseFilterForm from "./PurchaseFilterForm";
import { resetExtraFilters, setStoreFormValues } from "../../../../store/slices/Purchases/purchasesSlice";

const useFilterForm = (setShowform) => {
  const dispatch = useDispatch();

  const {
    franchiseId,
    isConfirmedId,
    startDate,
    endDate,
  } = useSelector((state) => state.purchasesList);
  const validationSchema = Yup.object({
    franchise: Yup.object().nullable(),
    isConfirmed: Yup.object().nullable(),
    startDate: Yup.date().nullable(),
    endDate: Yup.date().nullable(),
  });

  // Set the initial values based on whether edit is true or false
  const initialValues = {
    franchise: franchiseId,
    isConfirmed:isConfirmedId,
    startDate: startDate,
    endDate: endDate,
  
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      const {
        franchise,
        isConfirmed,
        startDate,
        endDate,
      } = values;

      if (
        franchise === "" &&
        isConfirmed === "" &&
        startDate === "" &&
        endDate === ""
      ) {
        toast.error("All fields are empty!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      } else {
        setShowform(false);
      }

      if (values) {
        dispatch(setStoreFormValues(values));
      }
    },
  });

  const renderTabContent = () => {
    return (
      <PurchaseFilterForm
        formik={formik}
        handleResetExtraFilters={handleResetExtraFilters}
      />
    );
  };

  const handleResetExtraFilters = () => {
    dispatch(resetExtraFilters());
    formik.resetForm();
    setShowform(false);
  };

  return {
    formik,
    renderTabContent,
    handleResetExtraFilters,
  };
};

export default useFilterForm;
